import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api'
import Loading from './plugins/loading'
import Message from './plugins/message'
import '@fortawesome/fontawesome-free/css/all.css'

// 全局配置
Vue.config.productionTip = false

// 全局API
Vue.prototype.$api = api
Vue.use(Loading)
Vue.use(Message)

// 将router实例设置为全局变量，以便在uni-app.js中使用
window.router = router

// 创建Vue实例
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
